import { render, staticRenderFns } from "./subprogram-nba-coach-card.vue?vue&type=template&id=3ae2c1ab&scoped=true&"
import script from "./subprogram-nba-coach-card.vue?vue&type=script&lang=js&"
export * from "./subprogram-nba-coach-card.vue?vue&type=script&lang=js&"
import style0 from "./subprogram-nba-coach-card.vue?vue&type=style&index=0&id=3ae2c1ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae2c1ab",
  null
  
)

export default component.exports